module.exports = __webpack_public_path__ + "static/media/whatsapp-notification.b903eeaa.mp3";